import React from "react"

const ICONS = {
  CLOSE: props => (
    <svg width="27" height="27" viewBox="0 0 27 27" {...props}>
      <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
    </svg>
  ),
  ARROW: props => (
    <svg width="12" height="8" viewBox="0 0 12 8" fill="none" {...props}>
      <path
        d="M10.59 0L6 4.58L1.41 0L0 1.41L6 7.41L12 1.41L10.59 0Z"
        fill="white"
      />
    </svg>
  ),
  ARROW_TO: props => (
    <svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11 4V0L18 7L11 14V9.9C6 9.9 2.5 11.5 0 15C1 10 4 5 11 4Z" fill="white"/>
    </svg>
  ),
  ARROW_TO_BLACK: props => (
    <svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11 4V0L18 7L11 14V9.9C6 9.9 2.5 11.5 0 15C1 10 4 5 11 4Z" fill="black"/>
    </svg>
  ),
  ARROW_LEFT: props => (
    <svg width="23" height="16" viewBox="0 0 23 16" fill="none" {...props}>
      <path
        d="M22.0052 8.07715H0.729675"
        stroke="#005475"
        strokeWidth="1.41837"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.82133 0.985352L0.729492 8.07719L7.82133 15.169"
        stroke="#005475"
        strokeWidth="1.41837"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  LINKEDIN: props => (
    <svg width="39" height="39" viewBox="0 0 39 39" fill="none" {...props}>
      <path
        d="M8.92211 39V13.4936H0.988684V39H8.92211ZM4.91274 10.0814C7.47191 10.0814 9.51924 7.94876 9.51924 5.38959C9.51924 2.91573 7.47191 0.868393 4.91274 0.868393C2.43888 0.868393 0.391544 2.91573 0.391544 5.38959C0.391544 7.94876 2.43888 10.0814 4.91274 10.0814ZM38.5232 39H38.6085V25.0099C38.6085 18.1854 37.073 12.8965 29.0542 12.8965C25.2155 12.8965 22.6563 15.0291 21.5473 16.9912H21.462V13.4936H13.8698V39H21.8033V26.3748C21.8033 23.0479 22.4004 19.8915 26.4951 19.8915C30.5897 19.8915 30.675 23.645 30.675 26.6307V39H38.5232Z"
        fill="#2EB4E9"
      />
    </svg>
  ),
  LINKEDIN_MAIN: props => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="39"
      height="39"
      {...props}
    >
      <path
        d="M29.63.001H2.362C1.06.001 0 1.034 0 2.306V29.69C0 30.965 1.06 32 2.362 32h27.27C30.937 32 32 30.965 32 29.69V2.306C32 1.034 30.937.001 29.63.001z"
        fill="#2A95BF"
      />
      <path
        d="M4.745 11.997H9.5v15.27H4.745zm2.374-7.6c1.517 0 2.75 1.233 2.75 2.75S8.636 9.9 7.12 9.9a2.76 2.76 0 0 1-2.754-2.753 2.75 2.75 0 0 1 2.753-2.75m5.35 7.6h4.552v2.087h.063c.634-1.2 2.182-2.466 4.5-2.466 4.806 0 5.693 3.163 5.693 7.274v8.376h-4.743V19.84c0-1.77-.032-4.05-2.466-4.05-2.47 0-2.85 1.93-2.85 3.92v7.554h-4.742v-15.27z"
        fill="#fff"
      />
    </svg>
  ),
  TRIANGLE_ARROW: props => (
    <svg
      width="10"
      height="5"
      viewBox="0 0 10 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M0 0L5 5L10 0H0Z" fill="#3DF1E0" />
    </svg>
  ),
  ECR_STAMP: props => (
    <svg width="117" height="129" viewBox="0 0 117 129" fill="none" {...props}>
      <path d="M87.4498 111.185C81.0463 113.874 74.1777 115.258 67.241 115.255C38.2697 115.255 14.6996 91.4911 14.6996 62.2848C14.6989 52.3682 17.4613 42.6509 22.672 34.2402C27.8827 25.8294 35.3321 19.0637 44.1712 14.7139C24.3345 22.529 10.9766 41.9412 10.9766 64.0154C10.9766 93.227 34.5492 116.993 63.5256 116.993C71.8454 117.007 80.0481 115.016 87.4498 111.185Z" />
      <path d="M104.811 98.6988C99.7768 104.813 93.4672 109.733 86.3316 113.107C79.1959 116.481 71.4099 118.227 63.5284 118.22C33.8361 118.22 9.76827 93.957 9.76827 64.0237C9.76827 34.5897 33.0433 10.6529 62.0479 9.86135V0C27.6447 0.796772 0 29.1391 0 64.016C0 99.3896 28.4452 128.068 63.5335 128.068C85.9387 128.068 105.614 116.36 116.932 98.6911L104.811 98.6988Z" />
    </svg>
  ),
  PATH: props => (
    <svg
      width="48"
      height="53"
      viewBox="0 0 48 53"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M35.9395 45.6441C33.3275 46.741 30.5259 47.3051 27.6964 47.3039C15.879 47.3039 6.26485 37.6108 6.26485 25.6976C6.26457 21.6527 7.39134 17.689 9.51677 14.2583C11.6422 10.8275 14.6808 8.0678 18.2863 6.29352C10.1949 9.48128 4.74622 17.3995 4.74622 26.4035C4.74622 38.3189 14.3615 48.013 26.1809 48.013C29.5745 48.0188 32.9204 47.2065 35.9395 45.6441Z"
        fill={props.fill || "#117733"}
      />
      <path
        d="M43.0206 40.551C40.9674 43.0451 38.3937 45.0517 35.4831 46.4281C32.5724 47.8044 29.3965 48.5165 26.1817 48.5136C14.0703 48.5136 4.25301 38.6168 4.25301 26.4071C4.25301 14.401 13.7469 4.63725 25.5778 4.31436V0.291931C11.5448 0.616933 0.268555 12.1777 0.268555 26.4039C0.268555 40.8328 11.8713 52.5307 26.1838 52.5307C35.3228 52.5307 43.3482 47.7549 47.9648 40.5479L43.0206 40.551Z"
        fill={props.fill || "#117733"}
      />
    </svg>
  ),
  SLIDER_ARROW: props => (
    <svg
      viewBox="0 0 12 22"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...props}
    >
      <path
        d="M10.6047 1.60449L2 10.9262L10.6047 20.248"
        strokeWidth="2.86823"
      />
    </svg>
  ),
  SCROLL_TOP_BLOCK: props => (
    <svg width="55" height="55" viewBox="0 0 55 55" fill="none" {...props}>
      <rect x="11" y="15" width="34" height="31" fill="#D9D9D9" />
      <path
        d="M27.5 55C42.68 55 55 42.68 55 27.5C55 12.32 42.68 0 27.5 0C12.32 0 0 12.32 0 27.5C0 42.68 12.32 55 27.5 55ZM27.5 22L38.5 33H16.5L27.5 22Z"
        fill="#473974"
      />
    </svg>
  ),
  SCROLL_TOP_BLOCK_WHITE: props => (
    <svg width="55" height="55" viewBox="0 0 55 55" fill="none" {...props}>
      <rect x="11" y="15" width="34" height="31" fill="#fff" />
      <path
        d="M27.5 55C42.68 55 55 42.68 55 27.5C55 12.32 42.68 0 27.5 0C12.32 0 0 12.32 0 27.5C0 42.68 12.32 55 27.5 55ZM27.5 22L38.5 33H16.5L27.5 22Z"
        fill="rgb(60,49,94)"
      />
    </svg>
  ),
  SEARCH_ICON: props => (
    <svg version="1.1" id="Layer_1" viewBox="0 0 512.001 512.001" {...props}>
      <g>
        <g>
          <g>
            <path
              d="M450.921,61.068c-45.324-45.322-119.07-45.322-164.395,0.001c-45.323,45.324-45.323,119.071,0,164.395
				c22.663,22.661,52.43,33.992,82.197,33.992c29.769,0,59.535-11.331,82.197-33.992h0.001
				C496.245,180.14,496.245,106.393,450.921,61.068z M439.768,214.31c-39.173,39.173-102.913,39.172-142.086,0.001
				c-39.173-39.174-39.173-102.914-0.001-142.087c19.59-19.589,45.313-29.38,71.045-29.38c25.725,0,51.459,9.796,71.043,29.38
				C478.941,111.397,478.941,175.137,439.768,214.31z"
            />
            <path
              d="M470.077,41.913c-55.886-55.883-146.817-55.885-202.706,0c-54.013,54.015-55.818,140.765-5.421,196.974l-20.118,20.118
				l11.153,11.154l20.119-20.118c27.13,24.325,61.373,36.492,95.619,36.492c36.705,0,73.41-13.972,101.353-41.914
				C525.963,188.734,525.963,97.8,470.077,41.913z M458.923,233.465c-49.737,49.737-130.662,49.734-180.396,0
				c-49.736-49.736-49.736-130.661,0-180.396c24.867-24.868,57.533-37.302,90.198-37.302c32.665,0,65.33,12.433,90.197,37.302
				C508.659,102.804,508.659,183.729,458.923,233.465z"
            />

            <rect
              x="207.55"
              y="269.468"
              transform="matrix(-0.7071 -0.7071 0.7071 -0.7071 204.4349 639.389)"
              width="54.178"
              height="15.774"
            />
            <path
              d="M0.009,475.288l36.712,36.712l202.057-203.354l-36.064-36.064L0.009,475.288z M36.685,489.656l-14.369-14.368
				l180.398-180.397l13.791,13.791L36.685,489.656z"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  CALENDAR_ICON: props => (
    <svg
      height="800px"
      width="800px"
      version="1.1"
      viewBox="0 0 397.445 397.445"
      {...props}
    >
      <path
        id="XMLID_63_"
        d="M260.9,229.825c0,4.971-4.029,9-9,9h-43.116c-4.971,0-9-4.029-9-9s4.029-9,9-9H251.9
	C256.871,220.825,260.9,224.854,260.9,229.825z M230.344,57.4c4.971,0,9-4.029,9-9V29.335c0-4.971-4.029-9-9-9s-9,4.029-9,9V48.4
	C221.344,53.371,225.373,57.4,230.344,57.4z M199.784,103.342c0,4.971,4.029,9,9,9H251.9c4.971,0,9-4.029,9-9s-4.029-9-9-9h-43.116
	C203.813,94.342,199.784,98.372,199.784,103.342z M251.9,157.583h-43.116c-4.971,0-9,4.029-9,9s4.029,9,9,9H251.9
	c4.971,0,9-4.029,9-9S256.871,157.583,251.9,157.583z M301.217,57.4c4.971,0,9-4.029,9-9V29.335c0-4.971-4.029-9-9-9s-9,4.029-9,9
	V48.4C292.217,53.371,296.246,57.4,301.217,57.4z M293.535,112.342h43.119c4.971,0,9-4.029,9-9s-4.029-9-9-9h-43.119
	c-4.971,0-9,4.029-9,9S288.564,112.342,293.535,112.342z M293.535,175.583h43.119c4.971,0,9-4.029,9-9s-4.029-9-9-9h-43.119
	c-4.971,0-9,4.029-9,9S288.564,175.583,293.535,175.583z M265.781,57.4c4.971,0,9-4.029,9-9V29.335c0-4.971-4.029-9-9-9
	s-9,4.029-9,9V48.4C256.781,53.371,260.811,57.4,265.781,57.4z M293.535,238.825h43.119c4.971,0,9-4.029,9-9s-4.029-9-9-9h-43.119
	c-4.971,0-9,4.029-9,9S288.564,238.825,293.535,238.825z M167.149,157.583h-43.117c-4.971,0-9,4.029-9,9s4.029,9,9,9h43.117
	c4.971,0,9-4.029,9-9S172.12,157.583,167.149,157.583z M203.907,48.4V29.335c0-4.971-4.029-9-9-9s-9,4.029-9,9V48.4
	c0,4.971,4.029,9,9,9S203.907,53.371,203.907,48.4z M167.149,94.342h-43.117c-4.971,0-9,4.029-9,9s4.029,9,9,9h43.117
	c4.971,0,9-4.029,9-9S172.12,94.342,167.149,94.342z M388.445,31.102h-42.791v-1.767c0-4.971-4.029-9-9-9s-9,4.029-9,9V48.4
	c0,4.971,4.029,9,9,9c4.734,0,8.614-3.655,8.973-8.298h33.818v234.963H208.106c-4.971,0-9,4.029-9,9s4.029,9,9,9h180.339
	c4.971,0,9-4.029,9-9V40.102C397.445,35.131,393.416,31.102,388.445,31.102z M164.94,222.623c3.515,3.515,3.515,9.213,0,12.728
	c-3.516,3.515-9.213,3.515-12.729,0l-0.377-0.377l-6.861,6.86c12.136,14.331,19.46,32.854,19.46,53.06
	c0,45.335-36.883,82.217-82.217,82.217C36.882,377.11,0,340.228,0,294.893c0-39.001,27.296-71.747,63.787-80.135
	c-0.069-0.451-0.105-0.914-0.105-1.384c0-4.971,4.029-9,9-9H91.75c4.971,0,9,4.029,9,9c0,0.471-0.036,0.933-0.105,1.384
	c11.531,2.651,22.147,7.735,31.271,14.679l7.192-7.191l-0.376-0.375c-3.515-3.515-3.515-9.213,0-12.728
	c3.516-3.516,9.213-3.516,12.729,0l6.659,6.659c0.027,0.026,0.054,0.053,0.081,0.08s0.053,0.054,0.079,0.081L164.94,222.623z
	 M82.217,230.675C46.808,230.675,18,259.483,18,294.893s28.808,64.217,64.217,64.217s64.217-28.808,64.217-64.217
	S117.626,230.675,82.217,230.675z M72.239,175.583c4.971,0,9-4.029,9-9V49.102h33.822c0.358,4.643,4.238,8.298,8.973,8.298
	c4.971,0,9-4.029,9-9V29.335c0-4.971-4.029-9-9-9s-9,4.029-9,9v1.767H72.239c-4.971,0-9,4.029-9,9v126.481
	C63.239,171.554,67.269,175.583,72.239,175.583z M101.279,285.893H91.215v-25.64c0-4.971-4.029-9-9-9s-9,4.029-9,9v34.64
	c0,4.971,4.029,9,9,9h19.064c4.971,0,9-4.029,9-9S106.25,285.893,101.279,285.893z M159.47,57.4c4.971,0,9-4.029,9-9V29.335
	c0-4.971-4.029-9-9-9s-9,4.029-9,9V48.4C150.47,53.371,154.499,57.4,159.47,57.4z"
      />
    </svg>
  ),
  LOCATION: props => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 1.5C7.85953 1.5 4.5 4.52391 4.5 8.25C4.5 14.25 12 22.5 12 22.5C12 22.5 19.5 14.25 19.5 8.25C19.5 4.52391 16.1405 1.5 12 1.5ZM12 12C11.4067 12 10.8266 11.8241 10.3333 11.4944C9.83994 11.1648 9.45542 10.6962 9.22836 10.1481C9.0013 9.59987 8.94189 8.99667 9.05764 8.41473C9.1734 7.83279 9.45912 7.29824 9.87868 6.87868C10.2982 6.45912 10.8328 6.1734 11.4147 6.05764C11.9967 5.94189 12.5999 6.0013 13.1481 6.22836C13.6962 6.45542 14.1648 6.83994 14.4944 7.33329C14.8241 7.82664 15 8.40666 15 9C14.9991 9.79538 14.6828 10.5579 14.1204 11.1204C13.5579 11.6828 12.7954 11.9991 12 12Z"
        fill="white"
      />
    </svg>
  ),
  EMAIL: props => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z"
        fill="white"
      />
    </svg>
  ),
  LIST_ICON: props => (
    <svg
      width="20"
      height="17"
      viewBox="0 0 20 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.1582 0.710938L6.78906 1.30469C6.86328 1.41602 6.9375 1.52734 6.9375 1.63867C6.9375 1.75 6.86328 1.86133 6.78906 1.93555L4.11719 4.64453L3.52344 5.20117C3.44922 5.27539 3.33789 5.34961 3.18945 5.34961C3.07812 5.34961 2.9668 5.27539 2.89258 5.20117L1.11133 3.45703C1.03711 3.38281 0.962891 3.27148 0.962891 3.12305C0.962891 3.01172 1.03711 2.90039 1.11133 2.82617L1.70508 2.23242C1.7793 2.1582 1.89062 2.12109 2.00195 2.12109C2.15039 2.12109 2.26172 2.1582 2.33594 2.23242L3.15234 3.04883L5.52734 0.710938C5.60156 0.636719 5.71289 0.5625 5.86133 0.5625C5.97266 0.5625 6.08398 0.636719 6.1582 0.710938ZM6.1582 6.61133L6.78906 7.24219C6.86328 7.31641 6.9375 7.42773 6.9375 7.57617C6.9375 7.6875 6.86328 7.79883 6.78906 7.87305L4.11719 10.5449L3.52344 11.1387C3.44922 11.2129 3.33789 11.2871 3.18945 11.2871C3.07812 11.2871 2.9668 11.2129 2.89258 11.1387L1.11133 9.35742C1.03711 9.2832 0.962891 9.17188 0.962891 9.06055C0.962891 8.94922 1.03711 8.83789 1.11133 8.72656L1.70508 8.16992C1.7793 8.0957 1.89062 8.02148 2.00195 8.02148C2.15039 8.02148 2.26172 8.0957 2.33594 8.16992L3.15234 8.98633L5.52734 6.61133C5.60156 6.53711 5.71289 6.5 5.86133 6.5C5.97266 6.5 6.08398 6.53711 6.1582 6.61133ZM3.375 13.0312C4.33984 13.0312 5.15625 13.8477 5.15625 14.8125C5.15625 15.8145 4.33984 16.5938 3.375 16.5938C2.37305 16.5938 1.55664 15.8145 1.55664 14.8125C1.55664 13.8477 2.37305 13.0312 3.375 13.0312ZM19.4062 13.625C19.7031 13.625 20 13.9219 20 14.2188V15.4062C20 15.7402 19.7031 16 19.4062 16H8.71875C8.38477 16 8.125 15.7402 8.125 15.4062V14.2188C8.125 13.9219 8.38477 13.625 8.71875 13.625H19.4062ZM19.4062 1.75C19.7031 1.75 20 2.04688 20 2.34375V3.53125C20 3.86523 19.7031 4.125 19.4062 4.125H8.71875C8.38477 4.125 8.125 3.86523 8.125 3.53125V2.34375C8.125 2.04688 8.38477 1.75 8.71875 1.75H19.4062ZM19.4062 7.6875C19.7031 7.6875 20 7.98438 20 8.28125V9.46875C20 9.80273 19.7031 10.0625 19.4062 10.0625H8.71875C8.38477 10.0625 8.125 9.80273 8.125 9.46875V8.28125C8.125 7.98438 8.38477 7.6875 8.71875 7.6875H19.4062Z"
        fill="white"
      />
    </svg>
  ),
  RETURN_ICON: props => (
    <svg
      width="18"
      height="15"
      viewBox="0 0 18 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7 4V0L0 7L7 14V9.9C12 9.9 15.5 11.5 18 15C17 10 14 5 7 4Z"
        fill="white"
      />
    </svg>
  ),
  DOWNLOAD_ICON: props => (
    <svg width="24" height="29" viewBox="0 0 24 29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M24 10.2353H17.1429V0H6.85714V10.2353H0L12 22.1765L24 10.2353ZM10.2857 13.6471V3.41176H13.7143V13.6471H15.72L12 17.3488L8.28 13.6471H10.2857ZM0 25.5882H24V29H0V25.5882Z" fill="white"/>
    </svg>
  ),
  TO_TOP_BLACK: props => (
    <svg width="24" height="15" viewBox="0 0 24 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M21.9834 12.9917L11.9917 3L1.99993 12.9917" stroke="#1E1E1E" stroke-width="3.07438"/>
    </svg>
  ),
  LAYER: props => (
    <svg width="652" height="982" viewBox="0 0 652 982" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M334.631 979.327L333.117 750.687C333.117 750.687 330.946 725.871 307.123 722.643L227.276 724.509" stroke="#999933" stroke-opacity="0.4" stroke-miterlimit="10"/>
      <path d="M2.52361 628.221L64.9073 689.202C68.7001 692.562 73.129 695.129 77.9318 696.749C82.7346 698.369 87.8138 699.01 92.8689 698.634C110.736 697.726 330.946 692.682 330.946 692.682C330.946 692.682 363.047 693.035 362.138 655.206" stroke="#999933" stroke-opacity="0.4" stroke-miterlimit="10"/>
      <path d="M251.099 598.663V408.205L480.041 399.025C490.548 397.698 501.18 397.698 511.687 399.025L618.991 442.15C618.991 442.15 648.82 454.962 649.275 485.225C649.729 515.489 649.275 911.487 649.275 911.487C649.275 911.487 649.729 944.07 625.452 947.248L334.631 979.327L227.276 902.357V724.509L84.2381 727.081C81.6133 727.133 79.0042 726.665 76.5613 725.704C74.1185 724.743 71.8901 723.308 70.005 721.482L5.90525 658.786C4.90361 657.817 4.10624 656.657 3.56014 655.375C3.01404 654.093 2.73026 652.715 2.7255 651.321L2.7255 630.54C2.72496 629.915 2.96629 629.314 3.39902 628.863C3.83175 628.412 4.42235 628.145 5.04722 628.119L217.434 619.999C217.434 619.999 248.727 623.63 251.301 598.663" stroke="#999933" stroke-opacity="0.4" stroke-miterlimit="10"/>
      <path d="M251.099 408.205L338.315 463.688C338.315 463.688 363.551 477.458 363.047 501.518C362.693 531.781 362.138 654.853 362.138 654.853" stroke="#999933" stroke-opacity="0.4" stroke-miterlimit="10"/>
      <path d="M290.821 406.641C290.821 406.641 305.963 404.774 307.073 384.145C308.183 363.515 307.073 308.738 307.073 308.738L261.648 310.756C258.476 310.875 255.341 310.046 252.644 308.375C249.947 306.703 247.81 304.266 246.506 301.374L149.095 84.0317C143.819 73.8352 141.214 62.469 141.524 50.9941V24.8666C141.524 24.8666 141.524 4.94315 159.391 2.87514C177.258 0.807134 408.472 7.91905 408.472 7.91905C408.472 7.91905 424.32 7.31379 435.323 26.4807C446.982 46.6563 533.693 230.457 551.409 266.975C551.737 267.666 551.887 268.428 551.846 269.192C551.804 269.956 551.573 270.697 551.171 271.349C550.77 272 550.212 272.541 549.549 272.922C548.885 273.304 548.136 273.513 547.371 273.532L280.676 282.359C277.521 282.529 274.387 281.744 271.686 280.106C268.984 278.469 266.84 276.054 265.534 273.179L151.871 26.2789C151.871 26.2789 143.846 6.70852 155.253 3.83348" stroke="#999933" stroke-opacity="0.4" stroke-miterlimit="10"/>
      <path d="M440.824 400.588C440.824 400.588 424.32 403.059 424.32 381.723V304.299L530.311 301.727C532.834 301.65 535.292 300.917 537.443 299.598C539.595 298.28 541.364 296.423 542.576 294.211L550.45 272.119" stroke="#999933" stroke-opacity="0.4" stroke-miterlimit="10"/>
      <path d="M328.927 308.738V390.046C328.927 390.046 329.281 401.799 333.975 405.178" stroke="#999933" stroke-opacity="0.4" stroke-miterlimit="10"/>
      <path d="M307.073 308.738L424.269 304.047" stroke="#999933" stroke-opacity="0.4" stroke-miterlimit="10"/>
      <path d="M299.3 416.929L506.135 408.254L598.348 449.917L380.46 463.233L299.3 416.929Z" stroke="#999933" stroke-opacity="0.4" stroke-miterlimit="10"/>
      <path d="M190.583 34.6523L412.106 39.6963L506.135 232.676L289.206 238.174L190.583 34.6523Z" stroke="#999933" stroke-opacity="0.4" stroke-miterlimit="10"/>
      <path d="M474.691 106.275V87.8138C474.691 87.8138 474.691 82.1142 478.88 82.7699C483.07 83.4256 531.876 82.7699 531.876 82.7699C533.784 82.3912 535.763 82.6874 537.476 83.6076C539.189 84.5279 540.528 86.0149 541.264 87.8138C544.797 94.4718 595.269 193.232 595.269 193.232C595.269 193.232 594.26 201.352 588.052 201.504L538.841 202.866C537.058 203.166 535.225 202.934 533.573 202.199C531.921 201.463 530.523 200.256 529.554 198.73C526.324 193.333 478.678 92.4542 478.678 92.4542C478.678 92.4542 473.631 83.0725 478.678 82.7194" stroke="#999933" stroke-opacity="0.4" stroke-miterlimit="10"/>
      <path d="M529.655 221.378L579.118 220.067C581.253 219.777 583.272 218.922 584.967 217.592C586.661 216.263 587.97 214.505 588.758 212.501C591.03 205.742 594.108 196.814 594.108 196.814" stroke="#999933" stroke-opacity="0.4" stroke-miterlimit="10"/>
    </svg>
  ),
}

const Icon = ({ type, ...props }) => {
  const IconComponent = ICONS[type]

  return <IconComponent {...props} />
}

export { Icon }
